import * as http from 'utils/http';
import config from 'config';
import debouncePromise from 'debounce-promise';

const fetchItinerary = async (id, baseURL) => {
  try {
    return await http.get(`${config.API_URL}${baseURL}/${id}/`);
  } catch (err) {
    const error = (await http.getError(err)) || {};
    throw new Error(error);
  }
};
const fetchRoutePlan = async (body) => {
  try {
    return await http.post(`${config.API_URL}itineraries/route-plan/`, body);
  } catch (err) {
    const error = (await http.getError(err)) || {};
    throw new Error(error);
  }
};

const createItinerary = async (body) => {
  try {
    return await http.post(`${config.API_URL}itineraries/`, body);
  } catch (err) {
    const error = (await http.getError(err)) || {};
    console.error(err);
    throw new Error(error);
  }
};

const fetchJourneyForRouting = async (journeyId) => {
  return http.get(`${config.API_URL}routing/journeys/${journeyId}/`);
};

const createRouteAssigned = async (journeyId, body) => {
  return http.patch(`${config.API_URL}mercury/journeys/${journeyId}/upgrade/`, body);
};

const debouncedFetchRoutePlan = debouncePromise(fetchRoutePlan, 200);

export {
  fetchItinerary,
  fetchRoutePlan,
  createItinerary,
  debouncedFetchRoutePlan,
  fetchJourneyForRouting,
  createRouteAssigned,
};

export { getError } from 'utils/http';
